import { Container } from '@chakra-ui/react';
import React, { useRef } from 'react';
import { Page } from '../../types';
import InfoHero from './InfoHero';
import ProgramTable from './ProgramTable.tsx';

const InfoMainPage: Page = () => {
  const scrollTo = () => {
    const el = document.querySelector('#program-table') as HTMLDivElement;
    if (el) {
      window.scrollTo({ behavior: 'smooth', top: el.offsetTop - 20 });
    }
  };

  return (
    <Container
      maxW={'8xl'}
      overflow={['hidden', 'hidden', 'hidden', 'visible']}
    >
      <InfoHero scrollTo={scrollTo} />
      <ProgramTable />
    </Container>
  );
};

InfoMainPage.getRoute = () => ['/info', '/explore', '/experience'] as any;

export default InfoMainPage;
